import { useState, RefObject } from 'react'
import { useLocation } from 'react-router-dom'

import { LANGUAGES_LIST } from 'consts/translations'
import LanguageIcon from 'assets/svgr-icons/Language.svg'
import * as Styled from './styled'
import { findAndGetSelectedLanguage } from './helpers'
import { UserDropdownExpandable } from '../UserDropdownExpandable'

interface IProps {
  scrollableContentWrapperRef: RefObject<HTMLDivElement | null>
}

export const UserDropdownLanguages: React.FC<IProps> = ({
  scrollableContentWrapperRef
}) => {
  const [selectedLanguage, setSelectedLanguage] = useState(
    findAndGetSelectedLanguage()
  )
  const { pathname } = useLocation()

  const changeLanguage = (lang: string) => {
    window.location.href = `${window.location.origin}/${lang}/v-editor${pathname}`
  }

  const options = LANGUAGES_LIST.filter(
    lang => lang.code !== selectedLanguage.code
  ).map(lang => ({ ...lang, id: lang.code }))

  return (
    <UserDropdownExpandable
      triggerId="language"
      triggerIcon={LanguageIcon}
      triggerLabel={selectedLanguage.label}
      options={options}
      renderOption={lang => (
        <>
          <Styled.UserDropdownLanguageFlag src={lang.flagImgSrc} />
          <Styled.UserDropdownLanguageText>
            {lang.label}
          </Styled.UserDropdownLanguageText>
        </>
      )}
      onSelect={lang => {
        setSelectedLanguage(lang)
        changeLanguage(lang.code)
      }}
      scrollableContentWrapperRef={scrollableContentWrapperRef}
    />
  )
}
